import React from 'react';
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";

import {
  getBetsState,
  getLiveSportsListRetail,
  getFirstLiveMatchBySport,
} from "../../store/selectors/betData";
import SearchLive from "../../components/search-live";
import FavoriteLiveMatch from "../../components/favorite-live-matches";
import LiveMatch from "../../components/live-matches";
import { getBaseRouterPath } from "../../utils/config";
import NewtonLoader from "../../../newton-loader";

//let scrollPos = 0;

const Home = (props) => {
  const { firstMatch, liveSports, fullStateLoaded, history } = props;

  const [state, setState] = React.useState({
    filter: "",
  });

  /*
  React.useEffect(() => {
    if (window.locationsHistory.pRoute && window.locationsHistory.pRoute.pathname) {
      const pPathname = window.locationsHistory.ppRoute.pathname;
      const pathname = window.locationsHistory.pRoute.pathname;
      if ((pPathname && pPathname === "/nsoft/live") && (pathname && pathname.indexOf('/nsoft/live/event')) > -1 && scrollPos) {
        try {
          setTimeout(() => {
            window.scrollTo(0, scrollPos);
          }, 100);
        } catch (e) { }
      }
    }
    return () => {
      try {
        scrollPos = window.scrollY || window.scrollTop || document.getElementsByTagName("html")[0].scrollTop;
      } catch (e) { }
    };
  }, []);
  */

  const handleSearchChange = (type, val) => {
    if (type === "tab" && val === 1 && firstMatch.idMatch) {
      history.push(`${getBaseRouterPath()}/live/event/${firstMatch.idSport}/${firstMatch.idCategory}/${firstMatch.idTournament}/${firstMatch.idMatch}`);
      return;
    }

    if (type === "filter") {
      setState(v => {
        if (v.filter !== val) {
          const tmp = { ...v };
          tmp.filter = val;
          return tmp;
        }
        return v;
      });
    }
  };

  return (
    <div className="content-wrap has-left-nav has-sidebar live">
      <SearchLive currentIndex={0} filter={state.filter} onChange={handleSearchChange} className="live" />
      <div className="elements">
        <FavoriteLiveMatch filter={state.filter} />
        {liveSports.map((s, i) => (
          <LiveMatch key={s.idSport} idSport={s.idSport} filter={state.filter} />
        ))}
        {!fullStateLoaded && <NewtonLoader theme="nsoft-live" />}
      </div>
    </div>
  );
}

const mapStateToProps = () => {
  return (state, props) => {
    const bst = getBetsState(state);

    const init = {
      mType: "live",
      idSPort: "0"
    };

    return {
      fullStateLoaded: bst.live.fullStateLoaded,
      liveSports: getLiveSportsListRetail(state, init),
      firstMatch: getFirstLiveMatchBySport(state, init),
    };
  };
};

export default connect(mapStateToProps)(withTranslation()(Home));
